import { render } from "./FeedBackModal.vue?vue&type=template&id=9ab81372&scoped=true"
import script from "./FeedBackModal.vue?vue&type=script&lang=js"
export * from "./FeedBackModal.vue?vue&type=script&lang=js"

import "./FeedBackModal.vue?vue&type=style&index=0&id=9ab81372&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9ab81372"]])

export default __exports__